import { Component, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { Title } from "@angular/platform-browser";
import { IncomeWealthService } from "../../service/income-wealth.service";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { LogService } from "../../../shared/service/log/log.service";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
@Component({
  selector: "app-patrimony",
  templateUrl: "./patrimony.page.html",
  styleUrls: ["./patrimony.page.scss"],
})
export class PatrimonyPageComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "income-patrimony";
  titlePage = "Renda e patrimônio";
  label = "Renda e patrimônio";
  placeholder = "R$ 0,00";
  inputTextValue = "";
  startStage = "";
  endStage = "";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  idLabelPatrimonyIncome = "idLabelPatrimonyIncome";
  idInputCurrencyIncomePatrimony = "idInputCurrencyIncomePatrimony";
  idButtonIncomePatrimony = "idButtonIncomePatrimony";

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    public incomeWealthService: IncomeWealthService,
    private title: Title,
    private logService: LogService,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest("patrimonio", "patrimony", "income");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    if (
      track.getName() === TrackTypes.BASIC ||
      track.getName() === TrackTypes.BASIC_V2 ||
      track.getName() === TrackTypes.CONTA_ION ||
      track.getName() === TrackTypes.CONTA_ION_INCOME
    ) {
      this.startStage = "2";
      this.endStage = "3";
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.patrimony;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathPatrimonio,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    const id =
      this.journeyService.registratioJourney.data.professionalData.originIncome;
    const patrimonyRequired =
      this.journeyService.registratioJourney.data.professionalData
        .patrimonyRequired;
    const idNotProf = ["11833", "11837", "11840"];
    const filterId = idNotProf.find((x) => x === id);

    if (
      (this.journeyService.journey === TrackTypes.BASIC &&
        filterId &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue)) ||
      (!this.journeyService.selectedTrack.isEventComunicator() &&
        patrimonyRequired &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue)) ||
      (this.journeyService.journey === TrackTypes.CONTA_ION &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue)) ||
      (this.journeyService.journey === TrackTypes.CONTA_ION_INCOME &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue))
    ) {
      this.inputTextValue = "0,00";
      localStorage.setItem("titleInf", "o seu patrimônio");
      localStorage.setItem("subTitleInf", "patrimônio");
      this.router.navigateForward(["error", "error-income"]);
    } else if (
      (this.journeyService.journey === TrackTypes.BASIC &&
        !filterId &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue)) ||
      (!this.journeyService.selectedTrack.isEventComunicator() &&
        !patrimonyRequired &&
        this.incomeWealthService.valueInformedEmpty(this.inputTextValue))
    ) {
      this.inputTextValue = "0,00";
      this.incomeWealthService.setCheckBoxPatrimony(true);
      this.incomeWealthService.setPatrimony(
        this.inputTextValue,
        this.journeyService.journey,
        this.journeyService.selectedTrack.isEventComunicator()
      );
      this.nextPage();
    } else {
      if (this.inputTextValue === "") {
        this.inputTextValue = "0,00";
      }
      this.incomeWealthService.setPatrimony(
        this.inputTextValue,
        this.journeyService.journey,
        this.journeyService.selectedTrack.isEventComunicator()
      );
      this.nextPage();
    }
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.patrimony,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  verifyStatusBtn() {
    return this.inputTextValueNoEmpty();
  }

  setInputTextValue($event: string) {
    this.inputTextValue = $event;
    this.logService.save(
      this.inputTextValue,
      "PatrimonyPageComponent.setInputTextValue"
    );

    this.inputTextValue = $event;
    this.incomeWealthService.setCheckBoxPatrimony(
      this.inputTextValue === "0,00" || this.inputTextValue === "0.00"
        ? true
        : false
    );
  }

  inputTextValueNoEmpty() {
    return this.inputTextValue.length > 0;
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  setEditPageRegistratio() {
    this.logService.save(
      this.journeyService.registratioJourney.data?.incomeEquity?.patrimony,
      "PatrimonyPageComponent.setEditPageRegistratio"
    );
    if (this.journeyService.registratioJourney.data?.incomeEquity?.patrimony) {
      if (
        this.journeyService.registratioJourney.data?.incomeEquity
          ?.noPatrimony === true ||
        this.journeyService.registratioJourney.data?.incomeEquity?.patrimony ===
          "0.00" ||
        this.journeyService.registratioJourney.data?.incomeEquity?.patrimony ===
          "0,00" ||
        this.journeyService.registratioJourney.data?.incomeEquity?.patrimony ===
          "00.00"
      ) {
        this.logService.save(
          "setChecked",
          "PatrimonyPageComponent.setEditPageRegistratio"
        );
        this.logService.save(
          this.journeyService.registratioJourney.data?.incomeEquity
            ?.noPatrimony,
          "PatrimonyPageComponent.setEditPageRegistratio"
        );
        this.inputTextValue = "";
      } else {
        const patrimony =
          typeof this.journeyService.registratioJourney.data?.incomeEquity
            ?.patrimony === "number" &&
          Number.isInteger(
            this.journeyService.registratioJourney.data?.incomeEquity?.patrimony
          )
            ? `${this.journeyService.registratioJourney.data?.incomeEquity?.patrimony}.00`
            : this.journeyService.registratioJourney.data?.incomeEquity?.patrimony.toString();

        this.logService.save(
          "setInputTextValue",
          "PatrimonyPageComponent.setEditPageRegistratio"
        );
        this.setInputTextValue(patrimony);
      }
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
}
